import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { Role, Event$, CompletedTask_$reflection, Region_$reflection, Course_$reflection, Track_$reflection, Event$_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, int32_type, string_type, record_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { ofArray, singleton, tryPick } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { Route_$007CBool$007C_$007C } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { sortBy, item, tryPick as tryPick_1, sortByDescending, tryHead, contains, equalsWith, tryFind, append, map as map_1, choose } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { dataFetchFailedView, tryParseInt } from "../Helpers.jsx";
import { isNullOrWhiteSpace, split } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { toArray, bind, map, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { RouterModule_encodeParts, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { formatRoute } from "../QueryParameters.jsx";
import { int32ToString, createObj, numberHash, defaultOf, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library-js.4.29.0/AsyncBuilder.js";
import { Task, Region, Course, Track, Event$ as Event$_1 } from "../ApiClient.jsx";
import { Result_ToOption } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { compare } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { SkeletonItem, Skeleton, Tooltip, Input, Switch, Text as Text$, Title3, Divider, Checkbox, Body1Strong, PopoverSurface, PopoverTrigger, Popover, CardFooter, Button, Link, Caption2, Label, Caption1, Badge, Subtitle1, tokens, Image, Card } from "@fluentui/react-components";
import { tryHead as tryHead_1, iterate, take, length as length_1, empty, singleton as singleton_2, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { WeatherSunnyLowRegular, ArrowResetRegular, SearchRegular, FilterRegular, LayerRegular, WarningFilled, LayerDiagonalPersonRegular, ArrowRightRegular, LocationRegular, MapRegular, PeopleQueueRegular, ClockRegular, CalendarRegular, CheckboxCheckedRegular, BookOpenRegular } from "@fluentui/react-icons";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { nb } from "date-fns/locale";
import { format as format_3 } from "date-fns";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Dialog } from "./AddEvent.jsx";

class Model extends Record {
    constructor(Events, AllTracks, AllCourses, AllRegions, IsFetchingEvents, UserCompletedTasks, EventsUserAttends, Filter) {
        super();
        this.Events = Events;
        this.AllTracks = AllTracks;
        this.AllCourses = AllCourses;
        this.AllRegions = AllRegions;
        this.IsFetchingEvents = IsFetchingEvents;
        this.UserCompletedTasks = UserCompletedTasks;
        this.EventsUserAttends = EventsUserAttends;
        this.Filter = Filter;
    }
}

function Model_$reflection() {
    return record_type("Event.ListEvents.Model", [], Model, () => [["Events", option_type(array_type(Event$_$reflection()))], ["AllTracks", array_type(Track_$reflection())], ["AllCourses", array_type(Course_$reflection())], ["AllRegions", array_type(Region_$reflection())], ["IsFetchingEvents", bool_type], ["UserCompletedTasks", array_type(CompletedTask_$reflection())], ["EventsUserAttends", array_type(Event$_$reflection())], ["Filter", Filter_$reflection()]]);
}

class Filter extends Record {
    constructor(SearchTerm, ShowOnlyEligible, ShowOnlyFromLevels, ShowOnlyOfCourses, ShowOnlyFromRegions) {
        super();
        this.SearchTerm = SearchTerm;
        this.ShowOnlyEligible = ShowOnlyEligible;
        this.ShowOnlyFromLevels = ShowOnlyFromLevels;
        this.ShowOnlyOfCourses = ShowOnlyOfCourses;
        this.ShowOnlyFromRegions = ShowOnlyFromRegions;
    }
}

function Filter_$reflection() {
    return record_type("Event.ListEvents.Filter", [], Filter, () => [["SearchTerm", string_type], ["ShowOnlyEligible", bool_type], ["ShowOnlyFromLevels", array_type(int32_type)], ["ShowOnlyOfCourses", array_type(int32_type)], ["ShowOnlyFromRegions", array_type(int32_type)]]);
}

function Filter_Empty() {
    return new Filter("", false, new Int32Array([]), new Int32Array([]), new Int32Array([]));
}

function Filter_fromParams_Z51B1D053(queryParams) {
    const searchTerm = tryPick((p) => {
        if (p[0] === "sok") {
            return p[1];
        }
        else {
            return undefined;
        }
    }, queryParams);
    const showOnlyEligible = tryPick((p_1) => {
        let matchResult, b;
        if (p_1[0] === "kunTilgjengelige") {
            const activePatternResult = Route_$007CBool$007C_$007C(p_1[1]);
            if (activePatternResult != null) {
                matchResult = 0;
                b = activePatternResult;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return b;
            default:
                return undefined;
        }
    }, queryParams);
    const showOnlyFromLevels = tryPick((p_2) => {
        if (p_2[0] === "nivaer") {
            return choose(tryParseInt, split(p_2[1], [","], undefined, 0), Int32Array);
        }
        else {
            return undefined;
        }
    }, queryParams);
    const showOnlyOfCourses = tryPick((p_3) => {
        if (p_3[0] === "kurs") {
            return choose(tryParseInt, split(p_3[1], [","], undefined, 0), Int32Array);
        }
        else {
            return undefined;
        }
    }, queryParams);
    const showOnlyFromRegions = tryPick((p_4) => {
        if (p_4[0] === "regioner") {
            return choose(tryParseInt, split(p_4[1], [","], undefined, 0), Int32Array);
        }
        else {
            return undefined;
        }
    }, queryParams);
    return new Filter(defaultArg(searchTerm, ""), defaultArg(showOnlyEligible, false), defaultArg(showOnlyFromLevels, new Int32Array([])), defaultArg(showOnlyOfCourses, new Int32Array([])), defaultArg(showOnlyFromRegions, new Int32Array([])));
}

function Filter__NavigateWithParams(this$) {
    let matchValue;
    RouterModule_nav(singleton(formatRoute((matchValue = this$.SearchTerm, (matchValue === "") ? undefined : matchValue), this$.ShowOnlyEligible, this$.ShowOnlyFromLevels, this$.ShowOnlyOfCourses, this$.ShowOnlyFromRegions)), 1, 1);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvents", "UpdateAllTracks", "UpdateAllCourses", "UpdateAllRegions", "SetIsFetching", "UpdateUserCompletedTasks", "UpdateEventsUserAttends", "UpdateFilter", "SignedUpTo", "WithdrewFrom"];
    }
}

function Msg_$reflection() {
    return union_type("Event.ListEvents.Msg", [], Msg, () => [[["Item", option_type(array_type(Event$_$reflection()))]], [["Item", array_type(Track_$reflection())]], [["Item", array_type(Course_$reflection())]], [["Item", array_type(Region_$reflection())]], [["Item", bool_type]], [["Item", array_type(CompletedTask_$reflection())]], [["Item", array_type(Event$_$reflection())]], [["Item", Filter_$reflection()]], [["Item", int32_type]], [["Item", int32_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Events, msg.fields[0], model.AllCourses, model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 2:
            return new Model(model.Events, model.AllTracks, msg.fields[0], model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 3:
            return new Model(model.Events, model.AllTracks, model.AllCourses, msg.fields[0], model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 4:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.AllRegions, msg.fields[0], model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 5:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.AllRegions, model.IsFetchingEvents, msg.fields[0], model.EventsUserAttends, model.Filter);
        case 6:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, msg.fields[0], model.Filter);
        case 7:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, msg.fields[0]);
        case 8: {
            const eventId = msg.fields[0] | 0;
            const newEvents = map((events_2) => map_1((event) => {
                if (event.Id === eventId) {
                    return new Event$(event.Id, event.Name, event.Enabled, event.Summary, event.Description, event.Address, event.MaxAttendees, event.AttendeeCount + 1, event.Time, event.EndTime, event.SignupDeadline, event.DateDescription, event.Finalized, event.Course, event.Teacher, event.SecondaryTeachers, event.Region);
                }
                else {
                    return event;
                }
            }, events_2), model.Events);
            return new Model(newEvents, model.AllTracks, model.AllCourses, model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, defaultArg(map((event_2) => append([event_2], model.EventsUserAttends), bind((array_1) => tryFind((event_1) => (event_1.Id === eventId), array_1), newEvents)), model.EventsUserAttends), model.Filter);
        }
        case 9: {
            const eventId_1 = msg.fields[0] | 0;
            return new Model(map((events_3) => map_1((event_3) => {
                if (event_3.Id === eventId_1) {
                    return new Event$(event_3.Id, event_3.Name, event_3.Enabled, event_3.Summary, event_3.Description, event_3.Address, event_3.MaxAttendees, event_3.AttendeeCount - 1, event_3.Time, event_3.EndTime, event_3.SignupDeadline, event_3.DateDescription, event_3.Finalized, event_3.Course, event_3.Teacher, event_3.SecondaryTeachers, event_3.Region);
                }
                else {
                    return event_3;
                }
            }, events_3), model.Events), model.AllTracks, model.AllCourses, model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends.filter((event_4) => (event_4.Id !== eventId_1)), model.Filter);
        }
        default:
            return new Model(msg.fields[0], model.AllTracks, model.AllCourses, model.AllRegions, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
    }
}

function init(queryParams) {
    return new Model(undefined, [], [], [], true, [], [], Filter_fromParams_Z51B1D053(queryParams));
}

function applyFilter(model, event) {
    const eventTrackLevels = choose((track) => tryFind((level) => level.TrackLevelCourses.some((tlc) => (tlc.Course.Id === event.Course.Id)), track.TrackLevels), model.AllTracks);
    const isEligible = (!equalsWith(equals, eventTrackLevels, defaultOf()) && (eventTrackLevels.length === 0)) ? true : eventTrackLevels.some((level_1) => level_1.RequiredTasks.every((requiredTask) => model.UserCompletedTasks.some((ct) => (ct.Task.Id === requiredTask.Id))));
    let isInLevelsToShow;
    const matchValue = model.Filter.ShowOnlyFromLevels;
    isInLevelsToShow = ((!equalsWith((x_1, y_1) => (x_1 === y_1), matchValue, defaultOf()) && (matchValue.length === 0)) ? true : matchValue.some((levelId) => eventTrackLevels.some((eventLevel) => (eventLevel.Id === levelId))));
    const isOneOfCoursesToShow = contains(event.Course.Id, model.Filter.ShowOnlyOfCourses, {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: numberHash,
    });
    let isInRegionsToShow;
    const matchValue_1 = model.Filter.ShowOnlyFromRegions;
    isInRegionsToShow = ((!equalsWith((x_3, y_3) => (x_3 === y_3), matchValue_1, defaultOf()) && (matchValue_1.length === 0)) ? true : contains(event.Region.Id, matchValue_1, {
        Equals: (x_4, y_4) => (x_4 === y_4),
        GetHashCode: numberHash,
    }));
    const searchTerm = model.Filter.SearchTerm.toLocaleLowerCase();
    const eventName = event.Name.toLocaleLowerCase();
    if ((((eventName.indexOf(searchTerm) >= 0) && (!model.Filter.ShowOnlyEligible ? true : isEligible)) && ((model.Filter.ShowOnlyFromLevels.length === 0) ? true : isInLevelsToShow)) && ((model.Filter.ShowOnlyOfCourses.length === 0) ? true : isOneOfCoursesToShow)) {
        if (model.Filter.ShowOnlyFromRegions.length === 0) {
            return true;
        }
        else {
            return isInRegionsToShow;
        }
    }
    else {
        return false;
    }
}

function Promises_fetchEvents(isAdmin, dispatch) {
    const pr = startAsPromise(singleton_1.Delay(() => singleton_1.TryFinally(singleton_1.Delay(() => singleton_1.Bind(isAdmin ? Event$_1.GetAll() : Event$_1.GetEnabled(), (_arg) => {
        dispatch(new Msg(0, [Result_ToOption(_arg)]));
        return singleton_1.Zero();
    })), () => {
        dispatch(new Msg(4, [false]));
    })));
    void pr;
}

function Promises_fetchTracks(isAdmin, dispatch) {
    const pr = startAsPromise(isAdmin ? Track.GetAll() : Track.GetAllEnabled());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(1, [res.fields[0]]));
        }
    }));
}

function Promises_fetchCourses(dispatch) {
    const pr = startAsPromise(Course.GetAllCourses());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
}

function Promises_fetchRegions(isAdmin, dispatch) {
    const pr = startAsPromise(isAdmin ? Region.GetAllRegions() : Region.GetEnabledRegions());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(3, [res.fields[0]]));
        }
    }));
}

function Promises_fetchUserCompletedTasks(dispatch) {
    const pr = startAsPromise(Task.GetMyCompleted());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(5, [res.fields[0]]));
        }
    }));
}

function Promises_fetchEventsUserAttends(dispatch) {
    const pr = startAsPromise(Event$_1.GetMy());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(6, [res.fields[0]]));
        }
    }));
}

function EventCard(eventCardInputProps) {
    let elems_19, elems_13, el_60, elems_18;
    const model = eventCardInputProps.model;
    const event = eventCardInputProps.event;
    let userIsBlockedByInactiveTrack;
    const array_1 = useCtx()[0].InactiveTracks;
    userIsBlockedByInactiveTrack = array_1.some((it) => it.BlockedCourses.some((bc) => (bc.Id === event.Course.Id)));
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const userIsAttending = model.EventsUserAttends.some((event$0027) => (event$0027.Id === event.Id));
    const lastCompletionDate = event.Course.Tasks.every((task) => model.UserCompletedTasks.some((ct) => (ct.Task.Id === task.Id))) ? tryHead(sortByDescending((x) => x, choose((task_1) => map((_arg) => _arg.Completed, tryFind((ct_1) => (ct_1.Task.Id === task_1.Id), model.UserCompletedTasks)), event.Course.Tasks), {
        Compare: compare,
    })) : undefined;
    const trackAndLevel = tryPick_1((track) => map((level_1) => [track, level_1], tryFind((level) => level.TrackLevelCourses.some((tlc) => (tlc.Course.Id === event.Course.Id)), track.TrackLevels)), model.AllTracks);
    const el_62 = Card;
    return createElement(el_62, createObj(ofArray([["key", `${event.Id}`], ["style", {
        display: "flex",
        padding: 0,
        gap: 0 + "px ",
    }], (elems_19 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["flexGrow", 1]), delay(() => append_1(singleton_2(["flexWrap", "wrap"]), delay(() => (isMobile ? append_1(singleton_2(["justifyContent", "center"]), delay(() => append_1(singleton_2(["padding", 12]), delay(() => singleton_2(["gap", 10 + "px "]))))) : append_1(singleton_2(["justifyContent", "space-between"]), delay(() => append_1(singleton_2(["padding", 15]), delay(() => singleton_2(["gap", 15 + "px "])))))))))))))))], (elems_13 = toList(delay(() => {
        let matchValue, thumbnailUrl_1, el, elems, el_2;
        return append_1((matchValue = event.Course.ThumbnailUrl, (matchValue != null) ? (!isNullOrWhiteSpace(matchValue) ? ((thumbnailUrl_1 = matchValue, singleton_2((el = Image, createElement(el, {
            style: createObj(toList(delay(() => append_1(isMobile ? append_1(singleton_2(["width", 100 + "%"]), delay(() => singleton_2(["height", 140]))) : append_1(singleton_2(["width", 100]), delay(() => singleton_2(["height", 80]))), delay(() => append_1(singleton_2(["borderRadius", 4]), delay(() => singleton_2(["objectFit", "cover"])))))))),
            src: thumbnailUrl_1,
        }))))) : singleton_2(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(isMobile ? append_1(singleton_2(["width", 100 + "%"]), delay(() => singleton_2(["height", 140]))) : append_1(singleton_2(["width", 100]), delay(() => singleton_2(["height", 80]))), delay(() => append_1(singleton_2(["borderRadius", 4]), delay(() => append_1(singleton_2(["backgroundColor", tokens.colorNeutralBackground3]), delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["alignItems", "center"]), delay(() => singleton_2(["justifyContent", "center"]))))))))))))))], (elems = [(el_2 = BookOpenRegular, createElement(el_2, {
            fontSize: 48,
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))) : singleton_2(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(isMobile ? append_1(singleton_2(["width", 100 + "%"]), delay(() => singleton_2(["height", 140]))) : append_1(singleton_2(["width", 100]), delay(() => singleton_2(["height", 80]))), delay(() => append_1(singleton_2(["borderRadius", 4]), delay(() => append_1(singleton_2(["backgroundColor", tokens.colorNeutralBackground3]), delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["alignItems", "center"]), delay(() => singleton_2(["justifyContent", "center"]))))))))))))))], (elems = [(el_2 = BookOpenRegular, createElement(el_2, {
            fontSize: 48,
            primaryFill: tokens.colorNeutralForeground3,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))))), delay(() => {
            let elems_10, elems_3, elems_9;
            return append_1(singleton_2(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                gap: 15 + "px ",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
            }], (elems_10 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["flexDirection", "row"]), delay(() => append_1(singleton_2(["flexWrap", "wrap"]), delay(() => append_1(singleton_2(["gap", 15 + "px "]), delay(() => append_1(singleton_2(["alignItems", "center"]), delay(() => (isMobile ? singleton_2(["justifyContent", "center"]) : empty()))))))))))))))], (elems_3 = toList(delay(() => {
                let el_4;
                return append_1(singleton_2((el_4 = Subtitle1, createElement(el_4, {
                    children: event.Name,
                }))), delay(() => {
                    let el_6;
                    return append_1(singleton_2((el_6 = Badge, createElement(el_6, {
                        children: event.Course.Name,
                    }))), delay(() => {
                        let elems_1, el_8, el_10, elems_2, el_12, el_14;
                        if (userIsAttending) {
                            return singleton_2(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                gap: 5 + "px ",
                                alignItems: "center",
                            }], (elems_1 = [(el_8 = CheckboxCheckedRegular, createElement(el_8, {})), (el_10 = Caption1, createElement(el_10, {
                                children: "Du er påmeldt",
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                        }
                        else {
                            const matchValue_1 = lastCompletionDate;
                            if (matchValue_1 == null) {
                                return singleton_2(defaultOf_1());
                            }
                            else {
                                const date = matchValue_1;
                                let formattedDate;
                                const locale = nb;
                                const formatOptions = {};
                                formatOptions.locale = locale;
                                formattedDate = format_3(date, "dd.MM.yyyy", formatOptions);
                                return singleton_2(createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    gap: 5 + "px ",
                                    alignItems: "center",
                                }], (elems_2 = [(el_12 = CheckboxCheckedRegular, createElement(el_12, {})), (el_14 = Caption1, createElement(el_14, {
                                    children: `Siste gjennomført ${formattedDate}`,
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                            }
                        }
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["gap", 20 + "px "]), delay(() => append_1(singleton_2(["flexWrap", "wrap"]), delay(() => (isMobile ? singleton_2(["justifyContent", "center"]) : empty()))))))))))], (elems_9 = toList(delay(() => {
                let elems_4, el_16, el_18, locale_1, formatOptions_1;
                return append_1(singleton_2(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 5 + "px ",
                }], (elems_4 = [(el_16 = CalendarRegular, createElement(el_16, {
                    fontSize: 24,
                    primaryFill: tokens.colorBrandBackground,
                })), (el_18 = Label, createElement(el_18, {
                    size: "medium",
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                    children: `${(locale_1 = nb, (formatOptions_1 = {}, (formatOptions_1.locale = locale_1, format_3(event.Time, "dd MMM yy", formatOptions_1))))}`,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let elems_5, el_20, el_22, locale_2, formatOptions_2;
                    return append_1(singleton_2(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        alignItems: "center",
                        gap: 5 + "px ",
                    }], (elems_5 = [(el_20 = ClockRegular, createElement(el_20, {
                        fontSize: 24,
                        primaryFill: tokens.colorBrandBackground,
                    })), (el_22 = Label, createElement(el_22, {
                        size: "medium",
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: `${(locale_2 = nb, (formatOptions_2 = {}, (formatOptions_2.locale = locale_2, format_3(event.Time, "HH:mm", formatOptions_2))))}`,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                        let elems_6, el_24, el_26;
                        return append_1(!isMobile ? singleton_2(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "center",
                            gap: 5 + "px ",
                        }], (elems_6 = [(el_24 = PeopleQueueRegular, createElement(el_24, {
                            fontSize: 24,
                            primaryFill: tokens.colorBrandBackground,
                        })), (el_26 = Label, createElement(el_26, {
                            size: "medium",
                            style: {
                                color: tokens.colorNeutralForeground3,
                            },
                            children: `${event.AttendeeCount}/${event.MaxAttendees}`,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                            let elems_7, el_28, el_30;
                            return append_1(singleton_2(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                gap: 5 + "px ",
                            }], (elems_7 = [(el_28 = MapRegular, createElement(el_28, {
                                fontSize: 24,
                                primaryFill: tokens.colorBrandBackground,
                            })), (el_30 = Label, createElement(el_30, {
                                size: "medium",
                                style: {
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: event.Region.Name,
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                let elems_8, el_32, el_34;
                                return append_1(singleton_2(createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 5 + "px ",
                                }], (elems_8 = [(el_32 = LocationRegular, createElement(el_32, {
                                    fontSize: 24,
                                    primaryFill: tokens.colorBrandBackground,
                                })), (el_34 = Label, createElement(el_34, {
                                    size: "medium",
                                    style: {
                                        color: tokens.colorNeutralForeground3,
                                    },
                                    children: event.Address,
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                    let el_38, el_36;
                                    return !event.Enabled ? singleton_2((el_38 = Badge, createElement(el_38, {
                                        style: {
                                            marginLeft: 10,
                                        },
                                        appearance: "tint",
                                        color: "warning",
                                        size: "large",
                                        children: (el_36 = Caption2, createElement(el_36, {
                                            children: "Utkast",
                                        })),
                                    }))) : empty();
                                }));
                            }));
                        }));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                let elems_12, el_44, elems_11, el_42, el_40;
                return singleton_2(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["flexDirection", "column"]), delay(() => append_1(singleton_2(["justifyContent", "center"]), delay(() => append_1(isMobile ? append_1(singleton_2(["flexGrow", 1]), delay(() => singleton_2(["paddingTop", 15]))) : empty(), delay(() => singleton_2(["minHeight", 100 + "%"]))))))))))))], (elems_12 = [(el_44 = Link, createElement(el_44, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["arrangement", int32ToString(event.Id)]), 1)], (elems_11 = [(el_42 = Button, createElement(el_42, {
                    style: {
                        width: 100 + "%",
                    },
                    icon: (el_40 = ArrowRightRegular, createElement(el_40, {})),
                    iconPosition: "after",
                    children: "Åpne",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))), (el_60 = CardFooter, createElement(el_60, createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
        padding: 15,
        alignItems: "center",
    }], (elems_18 = toList(delay(() => {
        let el_50, elems_14, el_48, el_46;
        if (trackAndLevel != null) {
            const track_1 = trackAndLevel[0];
            const level_2 = trackAndLevel[1];
            return append_1(singleton_2((el_50 = Link, createElement(el_50, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["laeringslop", int32ToString(track_1.Id)]), 1)], ["style", {
                textDecorationLine: "none",
            }], (elems_14 = [(el_48 = Button, createElement(el_48, {
                appearance: "subtle",
                size: "small",
                style: {
                    paddingLeft: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 5 + "px ",
                },
                icon: (el_46 = LayerDiagonalPersonRegular, createElement(el_46, {
                    fontSize: 24,
                    primaryFill: tokens.colorBrandBackground,
                })),
                children: track_1.Name,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_14))])]))))), delay(() => {
                let elems_17;
                return singleton_2(createElement("div", createObj(singleton((elems_17 = toList(delay(() => {
                    let elems_15, el_52, el_54;
                    return append_1(userIsBlockedByInactiveTrack ? singleton_2(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["alignItems", "center"]), delay(() => (isMobile ? append_1(singleton_2(["flexDirection", "column-reverse"]), delay(() => singleton_2(["gap", 5 + "px "]))) : append_1(singleton_2(["flexDirection", "row"]), delay(() => append_1(singleton_2(["justifyContent", "space-between"]), delay(() => singleton_2(["gap", 15 + "px "])))))))))))))], (elems_15 = [(el_52 = Caption1, createElement(el_52, {
                        children: "Dette kurset er ikke tilgjengelig på grunn av inaktivt læringsløp!",
                        style: {
                            color: tokens.colorStatusDangerBackground3,
                        },
                    })), (el_54 = WarningFilled, createElement(el_54, {
                        primaryFill: tokens.colorStatusDangerBackground3,
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))) : empty(), delay(() => {
                        let elems_16, el_58, el_56;
                        return singleton_2(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_2(["display", "flex"]), delay(() => append_1(singleton_2(["alignItems", "center"]), delay(() => (isMobile ? append_1(singleton_2(["flexDirection", "column-reverse"]), delay(() => singleton_2(["gap", 5 + "px "]))) : append_1(singleton_2(["flexDirection", "row"]), delay(() => singleton_2(["gap", 15 + "px "])))))))))))], (elems_16 = [(el_58 = Badge, createElement(el_58, {
                            icon: (el_56 = LayerRegular, createElement(el_56, {})),
                            children: level_2.Name,
                            appearance: "tint",
                            color: "success",
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_17))])))));
            }));
        }
        else {
            return singleton_2(createElement("div", {
                style: {
                    height: 24,
                },
            }));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_18))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_19))])])));
}

function FilterPopover(model) {
    let elems_4, el_4, el_2, el, el_20, elems_3, elems_1, el_14, elems_2, elemsToUse;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_22 = Popover;
    return createElement(el_22, createObj(ofArray([["trapFocus", true], ["positioning", {
        position: "below",
        align: "end",
    }], (elems_4 = [(el_4 = PopoverTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = FilterRegular, createElement(el, {})),
            iconPosition: "before",
            children: "Filter",
        })),
    })), (el_20 = PopoverSurface, createElement(el_20, createObj(ofArray([["style", createObj(toList(delay(() => append_1(isMobile ? singleton_2(["minWidth", 90 + "vw"]) : singleton_2(["minWidth", 500]), delay(() => append_1(singleton_2(["display", "flex"]), delay(() => singleton_2(["flexDirection", "row"]))))))))], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        gap: 5 + "px ",
        minWidth: 45 + "%",
    }], (elems_1 = toList(delay(() => append_1(map_1((track_1) => {
        let elems;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = toList(delay(() => {
            let el_6;
            return append_1(singleton_2((el_6 = Body1Strong, createElement(el_6, {
                children: track_1.Name,
            }))), delay(() => map_1((level) => {
                const el_8 = Checkbox;
                return createElement(el_8, {
                    label: level.Name,
                    checked: contains(level.Id, model.Filter.ShowOnlyFromLevels, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: numberHash,
                    }),
                    onChange: (_arg, c) => {
                        let bind$0040;
                        Filter__NavigateWithParams((bind$0040 = model.Filter, new Filter(bind$0040.SearchTerm, bind$0040.ShowOnlyEligible, Checkbox_toBool(c) ? append(new Int32Array([level.Id]), model.Filter.ShowOnlyFromLevels, Int32Array) : model.Filter.ShowOnlyFromLevels.filter((y_1) => (level.Id !== y_1)), bind$0040.ShowOnlyOfCourses, bind$0040.ShowOnlyFromRegions)));
                    },
                });
            }, track_1.TrackLevels)));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, model.AllTracks.filter((track) => (track.TrackLevels.length >= 1))), delay(() => {
        let el_10;
        return append_1(singleton_2((el_10 = Divider, createElement(el_10, {
            children: "Region",
        }))), delay(() => map_1((region) => {
            const el_12 = Checkbox;
            return createElement(el_12, {
                label: region.Name,
                checked: contains(region.Id, model.Filter.ShowOnlyFromRegions, {
                    Equals: (x_2, y_2) => (x_2 === y_2),
                    GetHashCode: numberHash,
                }),
                onChange: (_arg_1, c_1) => {
                    let bind$0040_1;
                    Filter__NavigateWithParams((bind$0040_1 = model.Filter, new Filter(bind$0040_1.SearchTerm, bind$0040_1.ShowOnlyEligible, bind$0040_1.ShowOnlyFromLevels, bind$0040_1.ShowOnlyOfCourses, Checkbox_toBool(c_1) ? append(new Int32Array([region.Id]), model.Filter.ShowOnlyFromRegions, Int32Array) : model.Filter.ShowOnlyFromRegions.filter((y_3) => (region.Id !== y_3)))));
                },
            });
        }, model.AllRegions)));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_14 = Divider, createElement(el_14, {
        vertical: true,
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
        minWidth: 45 + "%",
    }], (elems_2 = toList(delay(() => {
        let el_16;
        return append_1(singleton_2((el_16 = Body1Strong, createElement(el_16, {
            children: "Kurs",
        }))), delay(() => map_1((course) => {
            const el_18 = Checkbox;
            return createElement(el_18, {
                label: course.Name,
                checked: contains(course.Id, model.Filter.ShowOnlyOfCourses, {
                    Equals: (x_4, y_4) => (x_4 === y_4),
                    GetHashCode: numberHash,
                }),
                onChange: (_arg_2, c_2) => {
                    let bind$0040_2;
                    Filter__NavigateWithParams((bind$0040_2 = model.Filter, new Filter(bind$0040_2.SearchTerm, bind$0040_2.ShowOnlyEligible, bind$0040_2.ShowOnlyFromLevels, Checkbox_toBool(c_2) ? append(new Int32Array([course.Id]), model.Filter.ShowOnlyOfCourses, Int32Array) : model.Filter.ShowOnlyOfCourses.filter((courseId) => (courseId !== course.Id)), bind$0040_2.ShowOnlyFromRegions)));
                },
            });
        }, model.AllCourses)));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], (elemsToUse = ((length_1(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

export function View(viewInputProps) {
    let elems_11;
    const queryParams = viewInputProps.queryParams;
    const ctx = useCtx()[0];
    let patternInput_1;
    const arg_1 = init(queryParams);
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        Promises_fetchEvents(equals(ctx.User.Role, new Role(1, [])), dispatch);
        Promises_fetchTracks(equals(ctx.User.Role, new Role(1, [])), dispatch);
        Promises_fetchCourses(dispatch);
        Promises_fetchRegions(equals(ctx.User.Role, new Role(1, [])), dispatch);
        Promises_fetchUserCompletedTasks(dispatch);
        Promises_fetchEventsUserAttends(dispatch);
    });
    const dependencies = [queryParams];
    reactApi.useEffect(() => {
        dispatch(new Msg(7, [Filter_fromParams_Z51B1D053(queryParams)]));
    }, dependencies);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_11 = toList(delay(() => {
        let elems_2, elems, el, el_2, elems_1;
        return append_1(singleton_2(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Arrangementer",
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Påmelding Opplæring og Veiledning",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 5 + "px ",
        }], (elems_1 = toList(delay(() => {
            let matchValue, workplace, xs_1, el_4, el_6, matchValue_1;
            return append_1((matchValue = ctx.User.Workplace, (matchValue != null) ? ((workplace = matchValue, singleton_2((xs_1 = [(el_4 = Text$, createElement(el_4, {
                children: `Vis kun fra ${workplace.Region.Name}`,
            })), (el_6 = Switch, createElement(el_6, {
                checked: (matchValue_1 = model_1.Filter.ShowOnlyFromRegions, (!equalsWith((x, y) => (x === y), matchValue_1, defaultOf()) && (matchValue_1.length === 1)) && (item(0, matchValue_1) === workplace.Region.Id)),
                onChange: (_arg_2, value_1_2) => {
                    let bind$0040, bind$0040_1;
                    if (value_1_2.checked) {
                        Filter__NavigateWithParams((bind$0040 = model_1.Filter, new Filter(bind$0040.SearchTerm, bind$0040.ShowOnlyEligible, bind$0040.ShowOnlyFromLevels, bind$0040.ShowOnlyOfCourses, new Int32Array([workplace.Region.Id]))));
                    }
                    else {
                        Filter__NavigateWithParams((bind$0040_1 = model_1.Filter, new Filter(bind$0040_1.SearchTerm, bind$0040_1.ShowOnlyEligible, bind$0040_1.ShowOnlyFromLevels, bind$0040_1.ShowOnlyOfCourses, new Int32Array([]))));
                    }
                },
            }))], react.createElement(react.Fragment, {}, ...xs_1))))) : singleton_2(defaultOf_1())), delay(() => (equals(ctx.User.Role, new Role(1, [])) ? singleton_2(createElement(Dialog, {
                triggerText: "Opprett",
                appendEvent: (event) => {
                    iterate((events) => {
                        dispatch(new Msg(0, [sortBy((_arg_3) => _arg_3.Time, append([event], events), {
                            Compare: compare,
                        })]));
                        Filter__NavigateWithParams(Filter_Empty());
                    }, toArray(model_1.Events));
                },
            })) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let el_19, elems_5, el_10, el_8, elems_4, el_17, matchValue_2, el_14, el_12;
            return append_1(singleton_2((el_19 = Card, createElement(el_19, createObj(ofArray([["orientation", "horizontal"], ["style", {
                width: 100 + "%",
                display: "flex",
                justifyContent: "space-between",
            }], (elems_5 = [(el_10 = Input, createElement(el_10, {
                contentBefore: (el_8 = SearchRegular, createElement(el_8, {})),
                style: {
                    minWidth: 150,
                },
                placeholder: "Søk etter arrangement...",
                value: model_1.Filter.SearchTerm,
                onChange: (_arg_4, value_1_6) => {
                    let bind$0040_2;
                    const v = value_1_6;
                    Filter__NavigateWithParams((bind$0040_2 = model_1.Filter, new Filter(isNullOrWhiteSpace(v.value) ? "" : v.value, bind$0040_2.ShowOnlyEligible, bind$0040_2.ShowOnlyFromLevels, bind$0040_2.ShowOnlyOfCourses, bind$0040_2.ShowOnlyFromRegions)));
                },
            })), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                gap: 5 + "px ",
            }], (elems_4 = [createElement(FilterPopover, model_1), (el_17 = Tooltip, createElement(el_17, createObj(ofArray([["content", "Tilbakestill"], (matchValue_2 = tryHead_1([(el_14 = Button, createElement(el_14, {
                icon: (el_12 = ArrowResetRegular, createElement(el_12, {})),
                onClick: (_arg_5) => {
                    Filter__NavigateWithParams(Filter_Empty());
                },
                disabled: equals(model_1.Filter, Filter_Empty()),
            }))]), (matchValue_2 == null) ? ["children", defaultOf_1()] : ["children", matchValue_2])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))), delay(() => {
                let elems_7, el_31, el_33, elems_10, el_29, elems_6, el_21, el_23, el_25, el_27;
                const matchValue_3 = model_1.Events;
                if (matchValue_3 != null) {
                    const events_1 = matchValue_3;
                    return (events_1.length === 0) ? singleton_2(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }], (elems_7 = [(el_31 = WeatherSunnyLowRegular, createElement(el_31, {
                        primaryFill: tokens.colorBrandForeground1,
                        style: {
                            fontSize: 96 + "px",
                        },
                    })), (el_33 = Caption1, createElement(el_33, {
                        children: "Det finnes ingen arrangementer som er relevante for deg akkurat nå",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : singleton_2(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 15 + "px ",
                    }], (elems_10 = toList(delay(() => {
                        const filteredEvents = events_1.filter((event_1) => applyFilter(model_1, event_1));
                        return append_1(map_1((event_2) => createElement(EventCard, {
                            event: event_2,
                            model: model_1,
                        }), filteredEvents), delay(() => {
                            let elems_9, el_35, elems_8, el_37, matchValue_4, el_41, el_39;
                            return (!equals(model_1.Filter, Filter_Empty()) && (events_1.length > filteredEvents.length)) ? singleton_2(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 15 + "px ",
                            }], (elems_9 = [(el_35 = FilterRegular, createElement(el_35, {
                                fontSize: 48,
                                primaryFill: tokens.colorNeutralStroke1,
                            })), createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 5 + "px ",
                            }], (elems_8 = [(el_37 = Caption1, createElement(el_37, {
                                children: (matchValue_4 = ((events_1.length - filteredEvents.length) | 0), (matchValue_4 === 1) ? "Ett arrangement er filtrert bort" : (`${matchValue_4} arrangementer er filtrert bort`)),
                            })), (el_41 = Button, createElement(el_41, {
                                icon: (el_39 = ArrowResetRegular, createElement(el_39, {})),
                                size: "small",
                                children: "Tilbakestill filter",
                                onClick: (_arg_6) => {
                                    Filter__NavigateWithParams(Filter_Empty());
                                },
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty();
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                }
                else {
                    return model_1.IsFetchingEvents ? singleton_2((el_29 = Skeleton, createElement(el_29, createObj(ofArray([["style", {
                        width: 100 + "%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 10 + "px ",
                    }], (elems_6 = [(el_21 = SkeletonItem, createElement(el_21, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    })), (el_23 = SkeletonItem, createElement(el_23, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    })), (el_25 = SkeletonItem, createElement(el_25, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    })), (el_27 = SkeletonItem, createElement(el_27, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))) : singleton_2(dataFetchFailedView());
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
}

//# sourceMappingURL=ListEvents.jsx.map
